import {
    // FILE_UPLOAD,
    CREATE_ARCHITECTURESERVER,
    CREATEFRANCHISE_ARCHITECTURESERVER,
    RETRIEVE_ARCHITECTURESERVER,
    RETRIEVESINGLE_ARCHITECTURESERVER,
    UPDATE_ARCHITECTURESERVER,
    DELETE_ARCHITECTURESERVER,
} from "./type";
import ARCServers from "../service/arcServers";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await ARCServers.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await ARCServers.create(data);
        dispatch({
            type: CREATE_ARCHITECTURESERVER,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const franchiseApproval = (data) => async (dispatch) => {
    try {
        const res = await ARCServers.franchiseApproval(data);
        dispatch({
            type: CREATEFRANCHISE_ARCHITECTURESERVER,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await ARCServers.fetchList(data);
        dispatch({
            type: RETRIEVE_ARCHITECTURESERVER,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveServerList = (data) => async (dispatch) => {
    try {
        const res = await ARCServers.fetchList(data);
        dispatch({
            type: RETRIEVE_ARCHITECTURESERVER,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await ARCServers.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_ARCHITECTURESERVER,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await ARCServers.update(data);
        dispatch({
            type: UPDATE_ARCHITECTURESERVER,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await ARCServers.changeStatus(data);
//         dispatch({
//             type: UPDATE_ARCHITECTURESERVER,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await ARCServers.trash(data);
        dispatch({
            type: DELETE_ARCHITECTURESERVER,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};